import React, { useState } from 'react'
import Header from '../../components/application/dealerList/header'
import DealerListContent from '../../components/application/dealerList'

function Application() {
  // Manage shared search state at the container level
  const [searchTerm, setSearchTerm] = useState('');
  const [showSearchModal, setShowSearchModal] = useState(false);

  return (
    <>
      <Header
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        showSearchModal={showSearchModal}
        setShowSearchModal={setShowSearchModal}
      />
      <DealerListContent
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        showSearchModal={showSearchModal}
        setShowSearchModal={setShowSearchModal}
      />
    </>
  )
}

export default Application